import React from 'react';
import { useParams } from 'react-router-dom';

import PrivatePage from 'components/PrivatePage';
import { default as ResultComponent } from 'components/Result';

const Result = ({navbarProps}) => {
  const { id } = useParams();
  return (
    <PrivatePage navbarProps={navbarProps}>
      <ResultComponent id={id}/>
    </PrivatePage>
  )
}

export default Result;